import type React from 'react';

import { useGetResources } from '@hooks/useGetResources';
import { VerktoyFormal } from '@src/types/minhelseentities';

import { TagComponent } from './tag-component';

interface Props {
  verktoyFormal: VerktoyFormal;
}

const FormalTag = ({ verktoyFormal }: Props): React.JSX.Element | null => {
  const resources = useGetResources();
  switch (verktoyFormal) {
    case VerktoyFormal.Behandling:
      return <TagComponent tagValue={resources?.verktoyFormalBehandling} />;
    case VerktoyFormal.Informasjon:
      return <TagComponent tagValue={resources?.verktoyFormalInformasjon} />;
    case VerktoyFormal.Laring:
      return <TagComponent tagValue={resources?.verktoyFormalLaering} />;
    case VerktoyFormal.Veiledning:
      return <TagComponent tagValue={resources?.verktoyFormalVeiledning} />;
    case VerktoyFormal.Kartlegging:
      return <TagComponent tagValue={resources?.verktoyFormalKartlegging} />;
    case VerktoyFormal.Sjekkpunkt:
      return <TagComponent tagValue={resources?.verktoyFormalSjekkpunkt} />;
    case VerktoyFormal.Kontrollsporsmal:
      return <TagComponent tagValue={resources?.verktoyFormalKontrollsporsmal} />;
    default:
      return null;
  }
};

export default FormalTag;
